module.exports = "/packs/step5-sp-43e9024f460bd9963f8a5af2d49f05e8.png";